// extracted by mini-css-extract-plugin
module.exports = {"container":"Tag-module__container__2B0Ne","value":"Tag-module__value__2RvDH","dismiss-section":"Tag-module__dismiss-section__3RTg6","gradient":"Tag-module__gradient__1IwrH"};